import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

// Importa tu layout principal
import { MainLayoutComponent } from './shared/components/main-layout/main-layout';
// Importa el guard de autenticación
import { LoginAuthGuard } from './guards/login-auth.guard';

export const routes: Routes = [
  // Ruta raíz redirige al login
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  // Ruta de Login - NO usa el layout principal y NO requiere autenticación
  {
    path: 'login',
    loadComponent: () => import('./pages/authentication/login/login.component').then(m => m.LoginComponent)
  },

  // Rutas protegidas - Requieren autenticación
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [LoginAuthGuard], // Guard aplicado a todas las rutas hijas
    children: [
      {
        path: 'dashboard',
        redirectTo: 'inicio',
        pathMatch: 'full'
      },

      // Carga INICIO dentro del layout
      {
        path: 'inicio',
        loadComponent: () =>
          import('./pages/inicio/inicio').then(
            (m) => m.Inicio
          ),
      },
      {
        path: 'consultas',
        loadComponent: () =>
          import('./pages/consultas/consultas').then(
            (m) => m.Consultas
          ),
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./pages/reportes/reportes').then(
            (m) => m.ReportesComponent
          ),
      },
      {
        path: 'configuracion',
        loadComponent: () =>
          import('./pages/configuracion/configuracion').then(
            (m) => m.Configuracion
          ),
      },
    ],
  },

  // Redirige cualquier ruta no encontrada al login
  { path: '**', redirectTo: 'login' },
];
